<template>
  <footer class="rct-footer">
    <div class="rct-footer__left">
      <img :src="logoLight" alt="RidgeCodeTech" class="rct-footer__logo-img">
      <span class="rct-footer__copy">© {{ year }} RidgeCodeTech LLC. All rights reserved.</span>
    </div>
    <ul class="rct-footer__links">
      <li v-for="link in links" :key="link.href"><a :href="link.href">{{ link.label }}</a></li>
    </ul>
  </footer>
</template>

<script setup lang="ts">
import logoLight from '../assets/logo-light.png';
defineProps<{ links: { href: string; label: string }[] }>();
const year = new Date().getFullYear();
</script>

<style scoped>
.rct-footer { background: #091a38; border-top: 1px solid #1a3a6e; padding: 2.5rem 4rem; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem; }
.rct-footer__left { display: flex; align-items: center; gap: 0.75rem; }
.rct-footer__logo-img { height: 16px; width: auto; display: block; opacity: 0.6; }
.rct-footer__copy { font-size: 0.8rem; color: #6b82a0; }
.rct-footer__links { display: flex; gap: 1.75rem; list-style: none; }
.rct-footer__links a { font-size: 0.8rem; color: #6b82a0; text-decoration: none; transition: color 0.2s; }
.rct-footer__links a:hover { color: #becdea; }
@media (max-width: 768px) {
  .rct-footer { padding: 2rem 1.25rem; flex-direction: column; align-items: flex-start; gap: 1.25rem; }
  .rct-footer__links { flex-wrap: wrap; gap: 0.75rem 1.25rem; }
}
</style>
